<template>
  <div id="register">
    <div class="form-wrapper dark-form" v-show="showLoginMessage">
      <h1 class="title">Verify your email</h1>
      <p class="lead">
        We have sent an email with a confirmation link to your email address. In
        order to complete the sign-up process, please click the confirmation link.
      </p>
      <router-link to="/login">
        <a-button type="secondary" block class="login-form-button">Go to login page</a-button>
      </router-link>
    </div>
    <div class="form-wrapper" v-show="!showLoginMessage">
      <a-form :form="form" class="register-form" @submit="handleSubmit">
        <a-form-item>
          <a-alert type="error" :message="errorMessage" banner v-show="errorMessage" />
          <br>
          <a-input
            v-decorator="[
                'email',
                { rules: [
                        { required: true, message: 'Please input your email address!' },
                        { type: 'email', message: 'The input is not valid E-mail!', }
                    ]
                },
            ]"
            placeholder="Email address"
          >
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            :min="8"
            v-decorator="[
            'password',
            {
                rules: [
                {
                    required: true,
                    message: 'Please input your password!',
                },
                {
                    validator: validateToNextPassword,
                },
                {
                    min: 8,
                    message: 'Password has to have at least 8 characters',
                },
                ],
            },
            ]"
            type="password"
            placeholder="Password"
          >
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            :min="8"
            v-decorator="[
                'confirm',
                {
                    rules: [
                    {
                        required: true,
                        message: 'Please confirm your password!',
                    },
                     {
                        validator: compareToFirstPassword,
                    },
                    ],
                },
                ]"
            type="password"
            placeholder="Confirm password"
            @blur="handleConfirmBlur"
          >
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary" html-type="submit" class="register-form-button">Register</a-button>
          <a-divider>OR</a-divider>
          <router-link to="/login">
            <a-button type="secondary" block class="login-form-button">Login now!</a-button>
          </router-link>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      confirmDirty: false,
      errorMessage: null,
      showLoginMessage: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'register' });
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values);
          this.register(values);
        }
      });
    },
    handleConfirmBlur(e) {
      const { value } = e.target;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const { form } = this;
      if (value && value !== form.getFieldValue('password')) {
        callback('Two passwords that you enter is inconsistent!');
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const { form } = this;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },

    async register(data) {
      try {
        this.isBtnLoading = true;
        const email = data.email.toLowerCase();
        const result = await this.$Amplify.Auth.signUp({
          email,
          username: email,
          password: data.password,
          attributes: {
            email,
            name: email,
          },
        });
        const hasUser = !!result.user;

        if (!hasUser) {
          this.error = 'Something went wrong try again';
          this.isBtnLoading = false;
          return;
        }

        this.user = result.user;
        this.showLoginMessage = true;
      } catch (error) {
        const hasErrorCode = !!error.code;
        this.isBtnLoading = false;
        this.errorMessage = error.message;
        if (hasErrorCode) {
          this.error = error.message;
          return;
        }
        this.error = error;
      }
    },
  },
};
</script>

<style lang="scss">
#register {
  height: 100vh;
  text-align: left;
  display: grid;
  align-content: center;
  .form-wrapper {
    width: 300px;
    margin: 0 auto;
  }
  .register-form {
    max-width: 300px;
  }
  .register-form-forgot {
    float: right;
  }
  .register-form-button {
    width: 100%;
  }
}
</style>
